import { GenericValue } from 'hisng';

export const isGenericValue = ( value: unknown ): value is GenericValue => {
    return typeof value === 'object'
        && value != null
        && 'id' in value
        && typeof ( value as { id: number } ).id === 'number'
        && 'text' in value
        && typeof ( value as { text: string } ).text === 'string';
};
